// Angular Files
import {
 Component, Input, Output, EventEmitter, NgModule
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

// Angular Material Files
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';

// Teller Online Files
import { SearchResult } from 'apps/public-portal/src/app/core/services';

@Component({
    selector: 'app-separated-search-result',
    templateUrl: './separated-search-result.component.html',
    styleUrls: ['./separated-search-result.component.scss'],
    host: {
        class: 'separated-search-result',
        '[class.separated-search-result--load-more]': "item?.template === 'loadMore'"
    },
    standalone: false
})
export class SeparatedSearchResultComponent {
    // Public variables
    @Input() item: SearchResult;

    @Output() loadMore = new EventEmitter<void>();
}

@NgModule({
    declarations: [SeparatedSearchResultComponent],
    imports: [
        CommonModule,
        MatTooltipModule,
        MatButtonModule,
        RouterModule
    ],
    exports: [SeparatedSearchResultComponent]
})

export class SeparatedSearchResultModule { }
